export const entryRightTypes = {
    GET_MY_PRODUCTS_ENTRY_RIGHTS: "GET_MY_PRODUCTS_ENTRY_RIGHTS",
    GET_ENTRY_RIGHT_PRODUCTS: "GET_ENTRY_RIGHT_PRODUCTS",
    CLEAR_DELEGEE_DETAILS: "CLEAR_DELEGEE_DETAILS",
    DISPOSE_ERROR: "DISPOSE_ERROR",
    INVITE_DELEGEE: "INVITE_DELEGEE",
    REVOKE_ENTRY_RIGHTS: "REVOKE_ENTRY_RIGHTS",
    DELETE_ENTRY_RIGHT_DELEGEES: "DELETE_ENTRY_RIGHT_DELEGEES",
    TOGGLE_SHOW_REVOKE_ENTRY_RIGHT: "TOGGLE_SHOW_REVOKE_ENTRY_RIGHT",
    RESEND_INVITE: "RESEND_INVITE",
    RESEND_ALL_INVITES: "RESEND_ALL_INVITES",
    GET_ENTRY_RIGHT_DELEGEE: "GET_ENTRY_RIGHT_DELEGEE",
    UPDATE_DELEGEE: "UPDATE_DELEGEE",
    SELECT_ENTRY_RIGHT_ID_TO_EDIT: "SELECT_ENTRY_RIGHT_ID_TO_EDIT",
    TOGGLE_SHOW_DELETE_ENTRY_RIGHT_DELEGEES: "TOGGLE_SHOW_DELETE_ENTRY_RIGHT_DELEGEES",
    GET_ENTRY_DELEGEES_MYFLEET: "GET_ENTRY_DELEGEES_MYFLEET",
    GET_ENTRY_DELEGEES_MYFLEET_OVERVIEW: "GET_ENTRY_DELEGEES_MYFLEET_OVERVIEW",
    START_BULK_INVITATIONS: "START_BULK_INVITATIONS",
    VALIDATE_DELEGEES: "VALIDATE_DELEGEES",
    GET_BULK_IMPORT_PROGRESS: "GET_BULK_IMPORT_PROGRESS",
    GET_BULK_IMPORT_STATUS: "GET_BULK_IMPORT_STATUS",
    RESET_BULK_IMPORT_PROGRESS: "RESET_BULK_IMPORT_PROGRESS",
    GET_TOTAL_RECORDS: "GET_TOTAL_RECORDS",
} as const;